import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // DOM
        this.$button = this.$('button')[0]

        // Events
        this.events = {
            click: {
                button: 'onClick'
            }
        }
    }

    onClick(e) {
        e.preventDefault();

        const $page = document.querySelector('#page[tabindex]')
        const $firstAnchor = $page.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        const $target = $firstAnchor.length > 0 ? $firstAnchor[0] : $page

        if($target) {
            this.call('scrollTo', {
                target: $target,
            }, 'Scroll')

            $target.focus();
        }
    }

    setFocusable(focusable=true) {
        if(focusable) {
            this.$button.removeAttribute('tabindex')
        } else {
            this.$button.setAttribute('tabindex', '-1')
        }
    }
}
